module.exports = __webpack_public_path__ + "img/891811868.4ab1fac2.jpg";